import { useRef, useEffect, useState } from 'react';

function useInView() {
  const ref = useRef<HTMLDivElement>(null);
  const [inView, setInView] = useState(false);
  useEffect(() => {
    const obs = new IntersectionObserver(([e]) => { if (e.isIntersecting) setInView(true); }, { threshold: 0.1 });
    if (ref.current) obs.observe(ref.current);
    return () => obs.disconnect();
  }, []);
  return { ref, inView };
}

export default function TrustBar() {
  const { ref, inView } = useInView();

  return (
    <section className="bg-[#0A0A0A] border-y border-[#C9A84C]/15" ref={ref}>
      <div className="max-w-[1200px] mx-auto px-6 md:px-12 lg:px-16 py-12">

        {/* Stats row */}
        <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 mb-12 transition-all duration-700 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          {[
            { value: '4.8', suffix: '★', label: 'Google Rating', sub: 'Verified Reviews' },
            { value: '50+', suffix: '', label: 'Client Reviews', sub: 'Martindale-Hubbell' },
            { value: '50+', suffix: '', label: 'Years Combined', sub: 'Legal Experience' },
            { value: '2', suffix: '', label: 'Office Locations', sub: 'Central Coast CA' },
          ].map((s, i) => (
            <div key={i} className="flex flex-col items-center text-center group">
              <div className="font-serif text-[#C9A84C] text-[42px] font-bold leading-none mb-1.5">
                {s.value}<span className="text-2xl">{s.suffix}</span>
              </div>
              <div className="text-white text-sm font-semibold tracking-wide">{s.label}</div>
              <div className="text-white/30 text-[10px] tracking-[0.3em] uppercase mt-0.5">{s.sub}</div>
            </div>
          ))}
        </div>

        {/* Divider */}
        <div className="w-full h-px bg-gradient-to-r from-transparent via-[#C9A84C]/25 to-transparent mb-12"></div>

        {/* Credentials row */}
        <div className={`flex flex-wrap items-center justify-center gap-8 md:gap-12 transition-all duration-700 delay-200 ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}>
          {/* Martindale BV Distinguished */}
          <a
            href="https://www.martindale.com/organization/gamble-garcia-attorneys-300029651/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-55 hover:opacity-90 transition-opacity duration-300 cursor-pointer"
          >
            <img
              src="https://cdcssl.ibsrv.net/ibimg/smb/300x88_80/webmgr/21/1/4/Peer_BV_2024_300px.png.webp?6ea4c7ea2b36316fd5e0faac5498b3f1"
              alt="Martindale-Hubbell BV Distinguished 2024"
              className="h-11 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </a>
          {/* Client Reviewed */}
          <a
            href="https://www.martindale.com/organization/gamble-garcia-attorneys-300029651/"
            target="_blank"
            rel="noopener noreferrer"
            className="opacity-55 hover:opacity-90 transition-opacity duration-300 cursor-pointer"
          >
            <img
              src="https://cdcssl.ibsrv.net/ibimg/smb/300x88_80/webmgr/21/1/4/Client-reviewed_300px.png.webp?ddbc93a4f4cb3c6c437d22b143175b37"
              alt="Martindale-Hubbell Client Reviewed"
              className="h-11 w-auto object-contain"
              style={{ filter: 'brightness(0) invert(1)' }}
            />
          </a>

          <div className="w-px h-10 bg-white/8 hidden md:block"></div>

          {[
            { icon: 'ri-government-fill', text: 'California State Bar' },
            { icon: 'ri-building-4-fill', text: 'U.S. District Court — Central District' },
            { icon: 'ri-award-fill', text: 'Martindale-Hubbell Distinguished' },
          ].map((item, i) => (
            <div key={i} className="flex items-center gap-2.5">
              <div className="w-4 h-4 flex items-center justify-center">
                <i className={`${item.icon} text-[#C9A84C] text-sm`}></i>
              </div>
              <span className="text-white/45 text-[11px] tracking-wider whitespace-nowrap">{item.text}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
